// removed by extract-text-webpack-plugin
module.exports = {"button":"edu_2yRVW0SFj2Fze-607","active":"u2x3dBhLVA1ET0KZpq_C8 edu_2yRVW0SFj2Fze-607"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/BottomBar/Button/styles.scss
 ** module id = 500
 ** module chunks = 0
 **/